import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: { value: { email: "", password: "", header: false }, timerHistoryPayload: {}, taskStartTime: null },
  reducers: {
    login: (state, { payload }) => {
      state.value = payload;
    },
    logout: (state) => {
      state.value = { email: "", password: "" };
    },
    setLayout: (state, { payload }) => {
      state.layout = payload;
    },
    setToogleHeader: (state, { payload }) => {
      state.header = payload;
    },
    timerHistoryPayloadChange: (state, action) => {
      state.timerHistoryPayload = action.payload.data;
    },
    settaskStartTime(state, action) {
      state.taskStartTime = action.payload
    },
    timerPayloadUpdate: (state, action) => {
      state.timerHistoryPayload = {};
    }
  },
});

export const { login, logout, setLayout, setToogleHeader, timerHistoryPayloadChange, settaskStartTime, timerPayloadUpdate } = userSlice.actions;
export default userSlice.reducer;
